import styled from "styled-components";
import {
  DefaultParagraphLargeFactory,
  DefaultTitleLargeFactory,
} from "../core/Typograph/Typograph.Style";

export const SectionContainer = styled.div(
  ({ theme, themeColor, reverse, noPadding }) => ({
    background: themeColor
      ? theme.color.brandPrimary.light
      : theme.color.neutral["08"],
    color: themeColor ? theme.color.neutral["08"] : theme.color.neutral["02"],
    padding: noPadding ? "" : "40px 20px",
    display: "flex",
    flexDirection: "column",
    gap: 32,
    top: 0,

    [theme.breakpoint.lg()]: {
      padding: noPadding ? "" : "60px 112px",
      flexDirection: !reverse ? "row" : "row-reverse",
      gap: 64,
      alignItems: "center",
      justifyContent: "space-between",
    },
  })
);

export const Illustration = styled.div(({ theme }) => ({
  alignSelf: "stretch",
  svg: {
    maxWidth: "336px",
    width: "100%",

    [theme.breakpoint.xl()]: {
      maxWidth: "425px",
    },
  },
}));

export const SectionTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
}));

export const SectionParagraph = styled.p(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),
}));

export const SectionContent = styled.div(({ width, theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  [theme.breakpoint.xl()]: {
    width: width ? "62%" : "100%",
  },
}));

export const SectionButton = styled.button(({ theme }) => ({
  background: theme.color.neutral["08"],
  borderRadius: "500px",
  padding: "16px 36px",
  border: "none",
  color: theme.color.brandPrimary.light,
}));
